<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
        isActive: Boolean
    });
</script>


<template>
    <svg 
        v-if="isActive"
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M8 16L12 20M12 20L16 16M12 20V8M4 4H20" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
        />
    </svg>
    <svg 
        v-else
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M8 12L12 8M12 8L16 12M12 8V20M4 4H20" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
        />
    </svg>
</template>